import {RouteRecordRaw} from "vue-router";
import TeamsShow from "@/modules/team/pages/Show.vue";
import PlayersData from "@/modules/team/pages/players/Data.vue";
import PlayersTransfers from "@/modules/team/pages/players/Transfers.vue";
import PlayersOffers from "@/modules/team/pages/players/Offers.vue";
import PlayersLeavingPage from "@/modules/team/pages/players/LeavingPage.vue";
import CareerEndedPage from "@/modules/team/pages/players/CareerEndedPage.vue";
import PlayersCompetitionLogs from "@/modules/team/pages/players/CompetitionLogs.vue";
import SquadEntry from "@/modules/team/pages/squads/Entry.vue";
import SquadFormation from "@/modules/team/pages/squads/Formation.vue";
import SquadFormationBeforeMatch from "@/modules/team/pages/squads/FormationBeforeMatch.vue";
import SquadContracts from "@/modules/team/pages/squads/Contracts.vue";
import GenerateMatchPage from "@/modules/team/pages/GenerateMatchPage.vue";

export const routes: RouteRecordRaw[] = [
  {
    name: 'teams.show',
    path: '/teams/:id',
    component: TeamsShow,
  },
  {
    name: 'players.show',
    path: '/players/:id',
    redirect: to => ({name: 'players.show.data', params: to.params}),
  },
  {
    path: '/players/:id/data',
    name: 'players.show.data',
    component: PlayersData,
  },
  {
    path: '/players/:id/transfers',
    name: 'players.show.transfers',
    component: PlayersTransfers,
  },
  {
    path: '/players/:id/offers',
    name: 'players.show.offers',
    component: PlayersOffers,
  },
  {
    path: '/players/:id/competition-logs',
    name: 'players.show.competition-logs',
    component: PlayersCompetitionLogs,
  },
  {
    path: '/players/leaving',
    name: 'players.leaving',
    component: PlayersLeavingPage,
  },
  {
    path: '/players/career-ended',
    name: 'players.career-ended',
    component: CareerEndedPage,
  },
  {
    path: '/squads/formation/before-match',
    name: 'squads.formation.before-match',
    component: SquadFormationBeforeMatch,
  },
  {
    path: '/match/generate',
    name: 'match.generate',
    component: GenerateMatchPage,
  },
  {
    name: 'squads.entry',
    path: '/squads',
    component: SquadEntry,
    redirect: () => ({name: 'squads.formation'}),
    children: [
      {
        path: 'formation',
        name: 'squads.formation',
        component: SquadFormation,
      },
      {
        path: 'contracts',
        name: 'squads.contracts',
        component: SquadContracts,
        meta: {
          title: translator.t('contracts'),
          back: true,
        }
      },
    ]
  },
];